module.exports = __webpack_public_path__ + "img/logoPHP.719196fd.svg";